import { Box, Button, ThemeProvider, Typography } from '@mui/material'
import { FeatureFlagIdYearInReview2025 } from 'c1gen/features'
import { C1DarkTheme } from 'c1ui'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { palette } from 'c1ui/theme/palette'
import { useFeatureChecker } from 'components/no-ui/capability'
import { FC, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { yearInReviewApi } from 'redux_toolkit/year_in_review'
import { MIN_SECTION_THRESHOLD, titleGradient, YearInReviewModal } from './YearInReview'

export const YearInReviewBanner: FC = () => {
    const [modalOpen, setModalOpen] = useState(false)
    const hasFeature = useFeatureChecker(FeatureFlagIdYearInReview2025)
    const { data, isLoading } = yearInReviewApi.useGetYearInReview({ year: '2025' }, { actionable: !!hasFeature })

    if (isLoading || !hasFeature || !data?.metrics?.length) return null

    const metrics = data.metrics
    const getMetricValue = (key: string): number => {
        const m = metrics.find((x) => x.key === key)
        return m?.value.oneofKind === 'intValue' ? Number(m.value.intValue) : 0
    }

    // Hide if no meaningful activity
    const hasActivity = getMetricValue('total_certifications') >= MIN_SECTION_THRESHOLD
        || getMetricValue('total_requests_granted') >= MIN_SECTION_THRESHOLD
        || getMetricValue('total_requests_revoked') >= MIN_SECTION_THRESHOLD
    if (!hasActivity) return null

    return (
        <ThemeProvider theme={C1DarkTheme}>
            <Box
                sx={{
                    bgcolor: palette.brand.dark,
                    borderRadius: C1BorderRadius.large,
                    p: 3,
                    mb: 4,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 3,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box
                        component="img"
                        src="/dapi/static/images/branding/favicon-white/current/32"
                        alt="ConductorOne"
                        sx={{
                            width: 24,
                            height: 24,
                        }}
                    />
                    <Box>
                        <Typography
                            variant="h5"
                            component="span"
                            sx={{
                                fontWeight: 700,
                                background: titleGradient,
                                backgroundSize: '200% 200%',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            <FormattedMessage id="year_in_review_banner_title" defaultMessage="2025: Reviewed" />
                        </Typography>
                        <Typography>
                            <FormattedMessage
                                id="year_in_review_banner_description"
                                defaultMessage="See your year in identity governance"
                            />
                        </Typography>
                    </Box>
                </Box>
                <Button
                    variant="contained"
                    color="info"
                    onClick={(): void => setModalOpen(true)}
                >
                    <FormattedMessage id="year_in_review_banner_cta" defaultMessage="View" />
                </Button>
            </Box>
            <YearInReviewModal open={modalOpen} onClose={(): void => setModalOpen(false)} metrics={metrics} />
        </ThemeProvider>
    )
}
